import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type WrapType, type WrapBreakpointType, wrapList } from '../../typings/wrapType';
import { BreakpointDepended } from '../breakpointDepended';
import { defaults } from '../defaults';

export function withWrapProps(defaultValue?: WrapType | WrapBreakpointType) {
  return {
    /**
     * wrapowanie elementu (flex)
     */
    wrap: {
      type: [String, Object] as PropType<WrapType | WrapBreakpointType>,
      default: defaultValue
    }
  };
}

/**
 * Zwraca klasy wrapowania elementu (flex)
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withSizeProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useWrapProps = (prefix: string, props: ExtractPropTypes<ReturnType<typeof withWrapProps>>) => {
  return computed(() => {
    if (typeof props.wrap === 'string') {
      return `${prefix}--wrap-${props.wrap}`;
    }
    if (BreakpointDepended(props.wrap).value) {
      return `${prefix}--wrap-${BreakpointDepended(props.wrap).value}`;
    }
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesWrapArgs = {
  args: {
    wrap: defaults.flex.wrap
  },

  argTypes: {
    wrap: {
      options: wrapList,
      control: { type: 'select' }
    }
  }
};
